import React from "react";
import { Link } from "react-router-dom";

import logo from "assets/images/Logo.svg";
import { pathGenerators } from "utils/routes";

import styles from "../Sidebar.module.css";
import { SidebarMenuLinks } from "./SidebarMenuLinks";

export const SidebarMobile = ({
  isActive,
  onMenuClick,
  userrole,
  isAdmin,
  hasAccess,
  isMobileOpen,
  toggleMobileSidebar,
  closeMobileSidebar,
}) => (
  <>
    <button
      className="mobile-sidebar-toggle"
      onClick={toggleMobileSidebar}
      aria-label="Toggle menu"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 12H21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 6H21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 18H21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>

    <div
      className={`sidebar-overlay ${isMobileOpen ? "active" : ""}`}
      onClick={closeMobileSidebar}
      aria-hidden="true"
    />

    <div
      className={`${styles.sidebar} sidebar ${
        isMobileOpen ? styles.mobileOpen : ""
      }`.trim()}
    >
      <div className={styles.sidebarWrapper}>
        <Link
          className={styles.navbarBrand}
          to={pathGenerators.global.home()}
          onClick={onMenuClick}
        >
          <img src={logo} alt="logo" />
        </Link>
        <div className={styles.linksWrapper}>
          <SidebarMenuLinks
            styles={styles}
            isActive={isActive}
            onMenuClick={onMenuClick}
            userrole={userrole}
            isAdmin={isAdmin}
            hasAccess={hasAccess}
          />
        </div>
      </div>
    </div>
  </>
);
